import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UseCase } from '@domain/base/use-case';
import { UpdateUserBatchModel, UpdateUserBatchResult } from '@domain/models/update-user-batch.model';
import { UserRepository } from '@domain/repositories/user.repository';


@Injectable({
  providedIn: 'root',
})
export class DeleteUserBatchUseCase implements UseCase<string[], void> {
  constructor(private userRepository: UserRepository ) { }
  execute(ids: string[]): Observable<void> {
    return this.userRepository.deleteUserBatch(ids); 
  }
}
